import React from 'react'

const SignIn = () => (
  <div>
    SignIn page
  </div>
)

export default SignIn
